import { UnprocessableContentError, ViolationInterface } from '@systemeio/util'
import React, { Dispatch, SetStateAction } from 'react'
import { SafeHtmlText, toast } from 'shared/components'

type Parse422ErrorsType = Record<string, string>
type Options = {
  setCommonError?: (commonError: string) => void
}

const parse422Errors = (violations: ViolationInterface[]): Parse422ErrorsType => {
  const parsedViolations: Record<string, string> = {}

  violations.forEach(violation => {
    const { propertyPath, message } = violation

    parsedViolations[propertyPath] = parsedViolations[propertyPath]
      ? parsedViolations[propertyPath] + '\n' + message
      : message
  })

  return parsedViolations
}

const renderCommonErrorToast = (error: string) =>
  toast.error(React.createElement(SafeHtmlText, { as: 'p', html: error }))

export const handle422Error = <T>(
  e: unknown,
  setErrors: Dispatch<SetStateAction<T>>,
  options?: Options,
) => {
  if (e instanceof UnprocessableContentError) {
    const violations = e.errors.violations as ViolationInterface[]
    const parsedErrors = parse422Errors(violations)
    const { '': commonErrors, ...fieldErrors } = parsedErrors
    if (commonErrors) {
      if (options?.setCommonError) {
        options.setCommonError(commonErrors)
      } else {
        commonErrors.split('\n').forEach(renderCommonErrorToast)
      }
    }
    setErrors(prev => ({ ...prev, ...fieldErrors }))

    return fieldErrors
  }
}
